import React from 'react';

export const isReactNode = (elem: React.ReactNode): elem is React.ReactElement => {
  if (elem && typeof elem === 'object' && Object.prototype.hasOwnProperty.call(elem, 'type')) {
    return true;
  }

  return false;
};
